import queryString from 'simple-query-string';

export const getContentPayment = (username, serviceName) => {
  if (!username || !serviceName) {
    return 'ERROR PAYMENT';
  }

  return [username.toLowerCase(), serviceName].join(' ');
};

export const getQrPayment = (paymentData, amount = 0, note = '') => {
  const templateId = 'compact2';

  if (!paymentData || !paymentData.bin) {
    return '';
  }

  const payload = queryString.stringify({
    accountName: paymentData.owner,
    addInfo: note,
    amount: Number(amount),
  });

  return `https://img.vietqr.io/image/${paymentData.bin}-${paymentData.id}-${templateId}.jpg?${payload}`;
};
